import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
// import Editor from '@monaco-editor/react';

import {
  Box,
  Button,
  Divider,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import {
  CreateUsitcHtsCodeBIZcoreTD,
  UpdateUsitcHtsCodeBIZcoreTD
} from '../../../../../redux/actions/business/core/tradeDefencesActions';

import global from "../../../../../global.scss";

const MODES = { CREATE: 1, EDIT: 2 };

const Data = {
  HtsCode: "",
  Description: "",
  PrimaryUom: "",
  SecondaryUom: "",
  GeneralDutyRate: "",
};

const UsitcHtsCodesModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.CREATE);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.CREATE);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        if (update.defaultMode === MODES.CREATE) {
          setMode(MODES.CREATE);
        } else if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            HtsCode: update.hts_code || "",
            Description: update.description || "",
            PrimaryUom: update.primary_uom || "",
            SecondaryUom: update.secondary_uom || "",
            GeneralDutyRate: update.general_duty_rate ?? "",
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      hts_code: formData.HtsCode,
      description: formData.Description || null,
      primary_uom: formData.PrimaryUom || null,
      secondary_uom: formData.SecondaryUom || null,
      general_duty_rate: formData.GeneralDutyRate !== "" ? formData.GeneralDutyRate : null,
    };

    if (mode === MODES.CREATE) {
      dispatch(CreateUsitcHtsCodeBIZcoreTD(obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else if (mode === MODES.EDIT) {
      dispatch(UpdateUsitcHtsCodeBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* HTS Code */}
            <Box mb={"15px"}>
              <TextField
                label="HTS code"
                fullWidth
                name="HtsCode"
                value={formData.HtsCode}
                onChange={handleChange}
                inputProps={{ maxLength: 20 }}
              />
            </Box>

            {/* Description */}
            <Box mb={"15px"}>
              <TextField
                label="Description (optional)"
                fullWidth
                multiline
                minRows={3}
                name="Description"
                value={formData.Description}
                onChange={handleChange}
              />
            </Box>

            {/* Primary UOM + Secondary UOM */}
            <Box className="flexCenterSBRow" gap={"15px"} mb={"15px"}>
              <TextField
                label="Primary UOM (optional)"
                fullWidth
                name="PrimaryUom"
                value={formData.PrimaryUom}
                onChange={handleChange}
                inputProps={{ maxLength: 10 }}
              />
              <TextField
                label="Secondary UOM (optional)"
                fullWidth
                name="SecondaryUom"
                value={formData.SecondaryUom}
                onChange={handleChange}
                inputProps={{ maxLength: 10 }}
              />
            </Box>

            {/* General Duty Rate */}
            <Box mb={"15px"}>
              <TextField
                label="General duty rate (optional)"
                fullWidth
                name="GeneralDutyRate"
                value={formData.GeneralDutyRate}
                onChange={handleChange}
                type="number"
                inputProps={{ min: 0, step: "0.0001" }}
              />
            </Box>
          </Box>

          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={formData.HtsCode === ""}
              onClick={handleSubmit}
            >
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UsitcHtsCodesModal;
